import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const CateringIntroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-16 bg-muted/30 pt-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center sm:text-left">

            <div className="inline-flex items-center space-x-2 bg-accent/10 px-4 py-2 rounded-full mb-4">
              <Icon name="UtensilsCrossed" size={20} className="text-accent" />
              <span className="text-accent font-body font-medium">CATERING</span>
            </div>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-foreground mb-6">
              Catering for Your <span className="text-primary">Special Events</span>
            </h2>

            <p className="text-lg text-muted-foreground font-body mb-8 leading-relaxed">
              Bring Kahlovera's bold flavors to your next event. From corporate gatherings to private celebrations, we deliver exceptional food and service.
            </p>

            <Button
              onClick={() => navigate('/catering')}
              className="bg-accent text-accent-foreground hover:bg-accent/90 px-8 py-3 text-lg font-semibold rounded-lg shadow-warm hover:shadow-warm-lg transition-all duration-300">

              Explore Catering
            </Button>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="relative">

            <div className="relative rounded-2xl overflow-hidden shadow-warm-xl">
              <Image
                src="https://images.unsplash.com/photo-1555244162-803834f70033"
                alt="Beautifully arranged catering spread with colorful Mexican dishes and professional presentation"
                className="w-full h-[400px] object-cover" />

              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );

};

export default CateringIntroSection;